import { render, staticRenderFns } from "./SundryCreditorDetail.vue?vue&type=template&id=53bde2d9&scoped=true"
import script from "./SundryCreditorDetail.vue?vue&type=script&lang=js"
export * from "./SundryCreditorDetail.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorDetail.vue?vue&type=style&index=0&id=53bde2d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bde2d9",
  null
  
)

export default component.exports